import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import loginPageStyle from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx'
import { connect } from 'react-redux'
import { login } from 'actions/auth.js'
import { renderSnackbar } from 'actions/snackbar'
import LoginForm from 'views/Forms/LoginForm'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LogoFull from "assets/img/logos-wrapper.png";

const styles = require(`../../assets/css/style.jsx`).default;

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      loading: false,
      openPart:false,
      openHelp:false
    };
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }

  userLoggedIn = (data) => {
    this.setState({loading: true})
    // redirect to home on login success
    this.props.login(data)
      .then(() => this.props.history.push('/'))
      .catch(err => {
        this.props.renderSnackbar({
          color: 'danger',
          message: 'Nom d\'utilisateur ou mot de passe incorrecte.'
        })
        this.setState({loading: false})
      })
  }

  handleClickOpenPart = () => {
    this.setState({openPart:true})
  };

  handleClosePart = () => {
    this.setState({openPart:false})
  };

  handleClickOpenHelp = () => {
    this.setState({openHelp:true})
  };

  handleCloseHelp = () => {
    this.setState({openHelp:false})
  };

  render() {
    const { classes } = this.props
    const { loading } = this.state

    return (

      <div className={classes.content}>
        <div className={classes.container}>
          
          <div style={styles.btnBarLoginModal}>
            <Grid container direction="row" justify="center" alignItems="flex-start" >
              <img style={styles.fullLogo} src={LogoFull} alt='full-logo'></img>
            </Grid>
            
            <Button variant="outlined" color="primary" onClick={this.handleClickOpenPart} style={styles.btnLoginModal}>Comment participer à une opération</Button>
            <Dialog
              open={this.state.openPart}
              onClose={this.handleClosePart}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <p style={styles.modalTitle}>{"Comment ça marche ?"}</p>
                <IconButton aria-label="close" style={styles.closeButtonModal} onClick={this.handleClosePart}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <p style={styles.modalText}>
                    Pour participer à une opération, il vous suffit de :
                  </p>
                  <ol style={styles.modalListWrapper}>
                    <li style={styles.modalListItem}><span style={styles.modalListItemBold}>Télécharger</span> vos mandats</li>
                    <li style={styles.modalListItem}><span style={styles.modalListItemBold}>Déclarer</span> vos remboursements</li>
                    <li style={styles.modalListItem}><span style={styles.modalListItemBold}>Consulter le Statut de votre dossier</span> et vos remboursements</li>
                    <li style={styles.modalListItem}><span style={styles.modalListItemBold}>Conserver</span> vos données en toute confidentialité</li>
                  </ol>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </div>

          <GridContainer justify='center'>
            <GridItem xs={12} sm={6} md={4}>
              <LoginForm login={this.userLoggedIn} classes={classes} loading={loading}/>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  login: PropTypes.func.isRequired,
  renderSnackbar: PropTypes.func.isRequired
};

export default connect(null, { login, renderSnackbar })(withStyles(loginPageStyle)(LoginPage));



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx